import { render, staticRenderFns } from "./SuperRgpd.vue?vue&type=template&id=36af2950&"
import script from "./SuperRgpd.vue?vue&type=script&lang=js&"
export * from "./SuperRgpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports